import { Box, Skeleton } from '@mui/material';
import HeaderFallback from './components/header.fallback';

const WithdrawDetailsFallback = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
            }}>
            <Box sx={{ width: '100%', height: '100%' }}>
                <HeaderFallback title="جزئیات تسویه حساب">
                    <Skeleton variant="rectangular" height="550px" />
                </HeaderFallback>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    ml: { xs: 0, md: 2 },
                }}>
                <HeaderFallback title="لیست تراکنش ها">
                    <Skeleton
                        variant="rectangular"
                        height="200px"
                        sx={{ mt: 2 }}
                    />
                </HeaderFallback>
            </Box>
        </Box>
    );
};

export default WithdrawDetailsFallback;
